<template>
  <div class="comp-footer">
    <div class="footerH5" :style="{
    backgroundColor:data.temporaryPageEnd.chooseBGColor?data.temporaryPageEnd.chooseBGColor:''
  }">



      <!-- 左边是图片 -->
      <div v-if="data.temporaryPageEnd.leftContentImage" class="links">
        <div class="select">
          <img class="imageS" :src="data.temporaryPageEnd.logo">
        </div>
      </div>


      <!-- 左边是select -->
      <div v-if="data.temporaryPageEnd.leftContentSelect" class="links">
        <select placeholder="'友情链接'" class="select" v-model="selectedVal" @change="onSelect">
          <option style="display:none" value="" disabled>友情链接</option>
          <option v-for="(item, index)  in data.temporaryPageEnd.selectList" :value="item" :key=index>
            {{ item.linkName }}
          </option>
        </select>
      </div>

      <!-- 下面的文案 -->
      <div
        v-if="data.temporaryPageEnd.rightContentSelect"
        class="info"
        :style="{color:data.temporaryPageEnd.chooseBGColor=='#333333'?
        '#C0C4CC':data.temporaryPageEnd.chooseBGColor=='#FFFFFF'?'#606266':data.temporaryPageEnd.chooseBGColor=='#E2E6ED'?'#606266':''}"
      >
        <div class="itemText" v-for="(item, index) in data.temporaryPageEnd.rightContentList" :key="index" @click="clickPage(item)">
          {{ item.linkName }}
        </div>
      </div>



      <!-- 富文本展示 -->

      <div class="editC" v-if="data.temporaryPageEnd.copyrightSwitch" v-html="data.temporaryPageEnd.copyright">

      </div>

    </div>


  </div>


</template>
<script>
export default {
  props: {
    dataS: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedVal: '',
      frontendConfig: null,
      data: {
        isH5: false, // 是否是h5
        temporaryPageEnd: {
          token: '',
          menuList: [], // 导航菜单
          chooseBGColor: '', // 选中的颜色
          isShowLeftContent: false, // 是否显示左边内容
          leftContentImage: false, // 左部展示logo图片
          leftContentSelect: false, // 左部展示select选择框
          logo: '', // 底部页尾的logo
          selectList: [],// 下拉框选择
          copyrightSwitch: false, // 自定义展示
          rightContentList: [], // 右部文字内容
          rightContentSelect: false, // 选择右部文字内容部分
          copyright: null
        },
      }
    }
  },
  mounted() {
    // 初始化选中第一个
    console.log(this.dataS, '======-----')
    this.data.temporaryPageEnd = this.dataS;
    // this.selectedVal = this.data.temporaryPageEnd.selectList[0]
    this.$forceUpdate()
    // console.log(this.data.temporaryPageHeader, 'this.data.temporaryPageHeader')
  },
  methods: {

    // 点击时间
    clickPage(item){
      console.log('item',item)
      this.pushPage(item)
    },

    onSelect() {
      console.log(this.selectedVal, 'fsdfasdfsadf')
      this.pushPage(this.selectedVal)
    },

    // 跳转逻辑判断
    pushPage(item) {
      // if (!item.url) {
      //   return
      // }
      // if (item.menuLocation == 2) {
      //   item.openMode == 1 ? window.location.href = item.url : window.open(item.url, '_blank');
      // } else {
      //   this.$router.push({
      //     path: item.url,
      //   })
      // }
      if(!item.linkType){
        return
      }
      if(item.linkType==1||item.linkType==2){ // 自定义页面打开 系统页面
        let skipUrl = this.$router.resolve({
          path: item.jumpLink,
        });
        window.location.href = skipUrl.href; // 路由跳转需要结构出href
      }else if(item.linkType==3){
        window.location.href = item.jumpLink;
        // item.openMode == 1 ? window.location.href = item.jumpLink : window.open(item.jumpLink, '_blank');
      }

    }
  }
}
</script>
<style lang="stylus" scoped>
.comp-footer {
  .footerH5 {
    background: #333;
    height: auto;
    display: flex;
    flex-direction column
  }

  .links {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 20px 0px 16px;
    .select {
      width: 100%;
      img {
        max-width:300px
      }
      .imageS{
        max-width:300px
        //height 28px
      }
    }
  }

  .editC {
    margin-top 10px
    padding 0 20px
    box-sizing border-box
    margin-bottom 16px
  }

  .info {
    padding 10px 16px 0 16px
    box-sizing border-box
    width 100%
    .itemText {
      box-sizing border-box
      height: 42px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 42px;

    }
  }
}
</style>


